import React from "react";

const Contact = () => {
    return (
        <section id="contact" className="py-20 bg-cream">
            <div className="container mx-auto px-6 text-center">
                <h2 className="text-4xl font-bold  text-gray-800" style={{fontFamily:'Inria, serif'}}>Contact Me</h2>
                <h3 className="text-2xl font-bold mb-5 text-gray-800" style={{fontFamily:'Inria, serif'}}>Feel free to leave me a message</h3>
                <p className="text-xl font-bold mb-5 text-rosegold" style={{fontFamily:'Inria, serif'}}>
                     
                    fatimah3565@smk.belajar.id
                </p>
              

                <a href="mailto:fatimah3565@smk.belajar.id" className="bg-rose-700 hover:bg-rose-500 text-white font-bold py-2 px-3 rounded-2xl shadow-md transition duration-300">
                Send Mail <span>📧</span>
                </a>
            </div>
        </section>
    )
}

export default Contact